import { Navigate, type RouteObject } from 'react-router';
import { ReceiptDetailPage } from './features/receipts/pages/ReceiptDetailPage';
import { ReceiptsPage } from './features/receipts/pages/ReceiptsPage';
import { BILLING_TABS, billingTabPath } from './billing.paths';

/** The billing screens, for the router to place inside the office shell. */
export const BILLING_ROUTES: RouteObject[] = [
  { path: 'billing', element: <Navigate to={billingTabPath(BILLING_TABS[0])} replace /> },
  { path: 'billing/receipts', element: <ReceiptsPage /> },
  { path: 'billing/receipts/:id', element: <ReceiptDetailPage /> },
];
